export interface NavLink {
  key: string;
  label: string;
  anchor: string;
}

export const navLinks: NavLink[] = [
  { key: "home", label: "首页", anchor: "#home" },
  { key: "hot", label: "今日瓜榜", anchor: "#hot" },
  { key: "column", label: "热门栏目", anchor: "#column" },
  { key: "news", label: "最新瓜料", anchor: "#news" },
  { key: "join", label: "瓜友公约", anchor: "#join" },
  { key: "faq", label: "常见问题", anchor: "#faq" },
];

export interface StatItem {
  value: string;
  label: string;
}

export const stats: StatItem[] = [
  { value: "18万+", label: "注册瓜友" },
  { value: "3200+", label: "今日热帖" },
  { value: "96%", label: "当天有回复" },
  { value: "24h", label: "随时可加入" },
];

export interface Column {
  icon: string;
  title: string;
  desc: string;
  tag: string;
}

export const columns: Column[] = [
  { icon: "ri-movie-2-line", title: "影视热剧", desc: "热剧评分、剧情讨论、角色争议一网打尽。", tag: "剧荒终结站" },
  { icon: "ri-star-smile-line", title: "综艺名场面", desc: "名场面考古、导师金句、嘉宾互动复盘。", tag: "快乐源泉" },
  { icon: "ri-music-2-line", title: "华语音乐", desc: "新歌首发、颁奖典礼、榜单风向直击。", tag: "追更不停" },
  { icon: "ri-vip-crown-2-line", title: "内娱盘点", desc: "通告行程、红毯造型、营业动态随时聊。", tag: "八卦前线" },
  { icon: "ri-group-line", title: "饭圈文化", desc: "应援玩法、饭圈观察、追星心得交流。", tag: "同好汇聚" },
  { icon: "ri-megaphone-line", title: "民生热议", desc: "社会热点、公共事件、生活现象理性聊。", tag: "观点碰撞" },
  { icon: "ri-gamepad-line", title: "游戏圈", desc: "新游上线、电竞赛事、装备测评齐开麦。", tag: "上分搭子" },
  { icon: "ri-basketball-line", title: "体坛前线", desc: "赛事焦点、名将故事、体坛八卦轻松看。", tag: "热血围观" },
];

export interface HotTopic {
  id: string;
  rank: number;
  title: string;
  trend: "up" | "down" | "flat";
  heat: string;
}

export const hotTopics: HotTopic[] = [
  { id: "t1", rank: 1, title: "年度大热古偶《云上月》大结局引全网二刷", trend: "up", heat: "1.2亿" },
  { id: "t2", rank: 2, title: "顶流演唱会抢票盛况刷屏 你抢到了吗", trend: "up", heat: "9800万" },
  { id: "t3", rank: 3, title: "热门综艺新一期导师互怼名场面被盘出圈", trend: "flat", heat: "7600万" },
  { id: "t4", rank: 4, title: "某新剧OST上线一小时评论破百万", trend: "up", heat: "5300万" },
  { id: "t5", rank: 5, title: "红毯高定造型解析 谁是你心中的TOP1", trend: "down", heat: "4100万" },
  { id: "t6", rank: 6, title: "电竞战队夺冠赛后采访笑点拉满", trend: "up", heat: "3600万" },
  { id: "t7", rank: 7, title: "社会话题引热议：通勤路上的小确幸瞬间", trend: "flat", heat: "2900万" },
  { id: "t8", rank: 8, title: "古装剧服化道考古 剧组竟藏着这些细节", trend: "up", heat: "2200万" },
];

export interface NewsItem {
  id: string;
  column: string;
  date: string;
  reads: string;
  title: string;
  desc: string;
  img: string;
  hot: boolean;
}

export const newsItems: NewsItem[] = [
  {
    id: "n1",
    column: "影视热剧",
    date: "09-07",
    reads: "18.6万",
    title: "《云上月》大结局：编剧埋下的六个细节你看懂了吗",
    desc: "从服化道到台词callback，网友逐帧扒出制作组的用心伏笔，评论区二刷党纷纷盖章。",
    img: "https://readdy.ai/api/search-image?query=dramatic%20ancient%20costume%20drama%20still%20scene%20with%20warm%20lantern%20glow%20and%20flowing%20robes%2C%20cinematic%20soft%20lighting%2C%20rich%20red%20and%20gold%20palette&width=800&height=520&seq=news-01&orientation=landscape",
    hot: true,
  },
  {
    id: "n2",
    column: "综艺名场面",
    date: "09-07",
    reads: "12.3万",
    title: "名场面复盘：一句即兴回答为何能封神",
    desc: "一段被反复回味的综艺片段背后，是编剧、剪辑与嘉宾临场的化学反应，深度拆解爆红逻辑。",
    img: "https://readdy.ai/api/search-image?query=modern%20variety%20show%20studio%20with%20colorful%20spotlights%20and%20audience%2C%20energetic%20atmosphere%2C%20vivid%20warm%20tones%2C%20broadcast%20stage%20lighting&width=800&height=520&seq=news-02&orientation=landscape",
    hot: true,
  },
  {
    id: "n3",
    column: "华语音乐",
    date: "09-06",
    reads: "9.8万",
    title: "现象级OST走红背后：词曲作者一句话戳中泪点",
    desc: "当旋律撞上剧情情绪，一首歌如何成为无数人的单曲循环？主创分享创作幕后故事。",
    img: "https://readdy.ai/api/search-image?query=music%20studio%20with%20warm%20vinyl%20records%20and%20headphones%2C%20soft%20amber%20light%2C%20cozy%20musician%20atmosphere%2C%20close%20up%20detail&width=800&height=520&seq=news-03&orientation=landscape",
    hot: false,
  },
  {
    id: "n4",
    column: "内娱盘点",
    date: "09-06",
    reads: "15.1万",
    title: "红毯高光造型盘点：三套穿搭刷爆社交平台",
    desc: "从定制礼服到珠宝细节，造型团队如何打造让人过目不忘的绝美瞬间？一文看懂穿搭玄学。",
    img: "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20evening%20gown%20with%20dramatic%20train%2C%20warm%20golden%20bokeh%20background%2C%20luxury%20fashion%20editorial%20style&width=800&height=520&seq=news-04&orientation=landscape",
    hot: true,
  },
  {
    id: "n5",
    column: "饭圈文化",
    date: "09-05",
    reads: "7.4万",
    title: "从应援到公益：当代追星的N种打开方式",
    desc: "饭圈早已不是简单刷数据，越来越多同好用作品应援、用公益应援，让热爱有了更暖的模样。",
    img: "https://readdy.ai/api/search-image?query=colorful%20fan%20lightstick%20crowd%20at%20concert%2C%20warm%20stage%20lights%2C%20happy%20young%20audience%20with%20banner%2C%20festive%20energy&width=800&height=520&seq=news-05&orientation=landscape",
    hot: false,
  },
  {
    id: "n6",
    column: "游戏圈",
    date: "09-05",
    reads: "6.6万",
    title: "新版本更新解读：五大改动影响你的上分节奏",
    desc: "平衡性调整、新英雄登场、地图优化逐一拆解，老玩家给出的版本冲分实用建议都在这。",
    img: "https://readdy.ai/api/search-image?query=neon%20gaming%20setup%20with%20mechanical%20keyboard%20and%20vibrant%20screen%20glow%2C%20dark%20room%20with%20warm%20accent%20lighting%2C%20esports%20atmosphere&width=800&height=520&seq=news-06&orientation=landscape",
    hot: false,
  },
  {
    id: "n7",
    column: "民生热议",
    date: "09-04",
    reads: "5.2万",
    title: "城市漫步成为新潮流：用脚步重新认识身边",
    desc: "不用远行也能收获治愈，越来越多年轻人爱上在城市里慢慢走、慢慢看，你试过了吗？",
    img: "https://readdy.ai/api/search-image?query=young%20couple%20walking%20in%20charming%20old%20city%20streets%20at%20sunset%2C%20warm%20golden%20hour%20light%2C%20cozy%20urban%20exploration%20vibe&width=800&height=520&seq=news-07&orientation=landscape",
    hot: false,
  },
  {
    id: "n8",
    column: "体坛前线",
    date: "09-04",
    reads: "8.9万",
    title: "夺冠之夜：解说员哽咽背后是一整个赛季的坚持",
    desc: "从低谷到巅峰，他们用一场场比赛证明热爱。赛场之外的汗水与故事同样值得被记住。",
    img: "https://readdy.ai/api/search-image?query=championship%20trophy%20with%20confetti%20on%20sports%20field%20at%20night%2C%20warm%20stadium%20floodlights%2C%20celebration%20atmosphere%2C%20sports%20victory&width=800&height=520&seq=news-08&orientation=landscape",
    hot: false,
  },
];

export const columnsForNews: string[] = [
  "全部",
  "影视热剧",
  "综艺名场面",
  "华语音乐",
  "内娱盘点",
  "饭圈文化",
  "游戏圈",
  "民生热议",
  "体坛前线",
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  { q: "这是一个什么样的社区？", a: "这是一个面向所有瓜友的免费讨论聚集地。无论你追剧、听歌、聊综艺还是谈热点，都能在这里找到同好，随时围观、随时发言，不冷场是我们的唯一KPI。" },
  { q: "加入需要付费吗？", a: "完全免费。注册、发帖、评论、围观都不收取任何费用。我们坚持把吃瓜这件快乐的小事，留成每个人都能轻松参与的部分。" },
  { q: "新人如何快速找到感兴趣的话题？", a: "你可以从首页的「热门栏目」选择影视、综艺、音乐、游戏等分类，再点进任意瓜料进入讨论帖。也欢迎在发帖时带上栏目标签，让同好更快找到你。" },
  { q: "发言有什么需要遵守的规则？", a: "请保持友善、理性、就事论事。我们不欢迎人身攻击、造谣传谣与恶意刷屏。具体可查看「瓜友公约」，共同维护一个轻松又文明的讨论环境。" },
  { q: "内容会每天更新吗？", a: "会的。团队会持续跟进各栏目最新动态，每天都会补充新的瓜料和热门话题，保证你每次来都有新鲜内容可聊、可看、可讨论。" },
  { q: "我想聊的话题栏目里没有，该怎么办？", a: "欢迎直接开新帖分享！你也可以在评论区或意见反馈中告诉我们，呼声高的新栏目会优先安排上线。" },
];